import React from 'react'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'

ReactGA.initialize('UA-115980506-1');

class Transitionable extends React.Component {

  constructor(props) {
    super(props);
    this.state = { transitioned: false };
  }  

  componentDidMount() {
    this.transition()
    ReactGA.pageview(window.location.pathname + window.location.search)
  }

  transition() {
    this.context.transitionTo(this.robotState).then(() => {
      this.setState({
        transitioned: true
      })
    })
  }

  render() {
    if (this.state.transitioned) return this.renderTransitioned()
    else return <div />
  }

}

Transitionable.contextTypes = {
  transitionTo: PropTypes.func
}

export default Transitionable



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Transitionable/index.js